import reducer from "./stickersSlice";

export default reducer;
